<!--
Notifications screen
@author ab557z
-->

<template>
  <div id="contain" class="container">
    <Nav name="Notifications" :step="true" />
    <Spinner ref="spinner" />
    <main class="p-2">
      <div>
        <p @click="hideNotif" class="notifActionText2">Mark all as read</p>
      </div>
      <div style="margin-top:64px;margin-left:24px;margin-right:24px;" v-if="notifications[1]!=false">
        <NotifItem v-for="(notification,index) in notifications"
                  :key="index" :paramKey="index" :title="notification.title" :body="notification.body"
                  :time="notification.time" :icon="notification.icon" :link="notification.link" :unread="unread"
        />
      </div>
      <div v-if="notifications.length<1">
           <h5 style="color:#074C4C;text-align:center">Currently, you have no notifications.</h5>
      </div>
    </main>
    <div id="pusher"></div>
    <Footer active="notifications"/>
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

//Components
import NotifItem from '@/components/NewNotificationItem.vue'
import Footer from '@/components/FooterMenu.vue'

//Data
const notifications = ref({})
const unread = ref({})

//Component ref
const spinner = ref(null)

onMounted(
  () => {
    getNotif()
  }
)

function getNotif () {
  spinner.value.spin()
  axios.get('/timetable/notifications', { withCredentials: true })
    .then(response => {
      let fetchedNotifications = response.data.splice(1)
      unread.value = response.data[0]
      // if ($cookies.get('showNotifications') === 'true') {
      notifications.value = fetchedNotifications
    //  } else {
      //   if (this.unread > 0) {
      //    this.notifications = this.fetchedNotifications.slice(0, this.unread)
      // a  }
      // }
    })
    .finally(() => {
      spinner.value. stop()
      if (process.env.VUE_APP_MODE === 'hybrid') {
        window.FirebasePlugin.setBadgeNumber(0)
      }
    })
}

function showNotif () {
  lst.setValue('showNotifications', true)
  getNotif()
}

function hideNotif () {
  axios.post('/timetable/notifications/unread', { withCredentials: true })
    .then(() => {
      lst.setValue('unreadNotifications', 0)

      for (let i = 0; i < unread.value; i++) {
        document.getElementById('nibg' + i).removeAttribute('style', 'background-color:rgba(0, 56, 101, 0.1);')
      }
      unread.value = 0
    })
}

</script>

<style>

.notifActionText2 {
  float:right;
  margin-right:24px;
  margin-top:16px;
  font-weight:bold;
  color: var(--uog-dark-blue);
}

</style>
